import React, { useState, useEffect } from 'react';
import "./membership.css";
import { 
  FaSearch, 
  FaUserTie, 
  FaIdCard, 
  FaCalendarAlt, 
  FaMapMarkerAlt, 
  FaDirections, 
  FaPhone, 
  FaEnvelope, 
  FaBuilding,
  FaFilter,
  FaUsers,
  FaUserCheck,
  FaUserClock,
  FaUserTimes,
  FaMapMarkedAlt,
  FaExclamationCircle,
  FaCheckCircle,
  FaClock
} from 'react-icons/fa';
import { MdLocationOn, MdVerified, MdWarning } from 'react-icons/md';

function Membership() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMap, setSelectedMap] = useState(null);
  const [mapsLoading, setMapsLoading] = useState({});

  // Sample member data
  useEffect(() => {
    // Simulate API call
    setTimeout(() => {
      setMembers([
        {
          id: 1,
          name: "Robert Anderson",
          title: "Senior Business Consultant",
          membershipNo: "OPC-MEM-2024-001",
          validityStart: "2024-01-01",
          validityEnd: "2024-12-31",
          status: "active",
          company: "Anderson Consulting Group",
          email: "r.anderson@oprica.com",
          phone: "+1 (555) 123-4567",
          location: {
            address: "932, Maradana Road, Colombo 08",
            lat: 40.7128,
            lng: -74.0060,
            placeId: "ChIJMXEdSnRZ4joRF3TPiJm9T2E"
          },
          avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "business"
        },

        
        {
          id: 2,
          name: "Maria Garcia",
          title: "International Trade Specialist",
          membershipNo: "OPC-MEM-2024-045",
          validityStart: "2024-03-15",
          validityEnd: "2025-03-14",
          status: "active",
          company: "Global Trade Solutions",
          email: "m.garcia@oprica.com",
          phone: "+1 (555) 234-5678",
          location: {
            address: "456 Commerce Blvd, Los Angeles, CA 90001",
            lat: 34.0522,
            lng: -118.2437,
            placeId: "ChIJE9on3F3HwoAR9AhGJW_fL-I"
          },
          avatar: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "trade"
        },
        {
          id: 3,
          name: "James Wilson",
          title: "Supply Chain Expert",
          membershipNo: "OPC-MEM-2023-112",
          validityStart: "2023-06-01",
          validityEnd: "2024-05-31",
          status: "Active",
          company: "Wilson Logistics",
          email: "j.wilson@oprica.com",
          phone: "+1 (555) 345-6789",
          location: {
            address: "789 Industrial Park, Chicago, IL 60601",
            lat: 41.8781,
            lng: -87.6298,
            placeId: "ChIJ7cv00DwsDogRAMDACa2m4K8"
          },
          avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "logistics"
        },
        {
          id: 4,
          name: "Patricia Lee",
          title: "Financial Advisor",
          membershipNo: "OPC-MEM-2023-089",
          validityStart: "2023-02-10",
          validityEnd: "2024-02-09",
          status: "expired",
          company: "Lee Financial Group",
          email: "p.lee@oprica.com",
          phone: "+1 (555) 456-7890",
          location: {
            address: "321 Finance Plaza, San Francisco, CA 94105",
            lat: 37.7749,
            lng: -122.4194,
            placeId: "ChIJIQBpAG2ahYAR_6128GcTUEo"
          },
          avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "finance"
        },
        {
          id: 5,
          name: "David Kim",
          title: "Technology Consultant",
          membershipNo: "OPC-MEM-2024-023",
          validityStart: "2024-02-01",
          validityEnd: "2025-01-31",
          status: "active",
          company: "Digital Innovations Inc",
          email: "d.kim@oprica.com",
          phone: "+1 (555) 567-8901",
          location: {
            address: "567 Tech Hub, Seattle, WA 98101",
            lat: 47.6062,
            lng: -122.3321,
            placeId: "ChIJVTPokywQkFQRmtVEaUZlJRA"
          },
          avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "technology"
        },
        {
          id: 6,
          name: "Sarah Thompson",
          title: "Marketing Director",
          membershipNo: "OPC-MEM-2024-078",
          validityStart: "2024-04-01",
          validityEnd: "2025-03-31",
          status: "active",
          company: "Thompson Marketing",
          email: "s.thompson@oprica.com",
          phone: "+1 (555) 678-9012",
          location: {
            address: "890 Creative Ave, Austin, TX 78701",
            lat: 30.2672,
            lng: -97.7431,
            placeId: "ChIJLwPMoJm1RIYRetVp1EtGm10"
          },
          avatar: "https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80",
          category: "marketing"
        }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const getStatusBadge = (status) => {
    switch(status) {
      case 'active':
        return <span className="validity-badge active"><FaCheckCircle /> Active</span>;
      case 'expiring':
        return <span className="validity-badge expiring"><FaClock /> Expiring Soon</span>;
      case 'expired':
        return <span className="validity-badge expired"><FaExclamationCircle /> Expired</span>;
      default:
        return null;
    }
  };

  const getDirections = (location) => {
    if (!location) return;
    
    // Construct Google Maps URL
    const url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(location.address)}&destination_place_id=${location.placeId || ''}`;
    
    // Open in new tab
    window.open(url, '_blank');
  };

  const loadGoogleMap = (memberId, location) => {
    setMapsLoading(prev => ({ ...prev, [memberId]: true }));
    setSelectedMap(memberId);
    
    // Simulate map loading
    setTimeout(() => {
      setMapsLoading(prev => ({ ...prev, [memberId]: false }));
    }, 1500);
  };

  const filteredMembers = members.filter(member => {
    const matchesSearch = 
      member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.membershipNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.location.address.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterStatus === 'all' || member.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  const statistics = {
    total: members.length,
    active: members.filter(m => m.status === 'active').length,
    expiring: members.filter(m => m.status === 'expiring').length,
    expired: members.filter(m => m.status === 'expired').length
  };

  return (
    <div className="membership-container">
      {/* Hero Section */}
      <section className="membership-hero">
        <div className="membership-hero-content">
          <h1>
            <span>Optica International</span> <br />Members Directory
          </h1>
          <p>
            Connect with our global network of professionals and business partners.
            Find members by name, membership number, or location.
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="search-filter-section">
        <div className="container">
          <div className="search-bar">
            <div className="search-input-wrapper">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by name, membership number, company, or location..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>
          
          <div className="filter-buttons">
            <button 
              className={`filter-btn ${filterStatus === 'all' ? 'active' : ''}`}
              onClick={() => setFilterStatus('all')}
            >
              <FaUsers /> All Members
            </button>
            <button 
              className={`filter-btn ${filterStatus === 'active' ? 'active' : ''}`}
              onClick={() => setFilterStatus('active')}
            >
              <FaUserCheck /> Active
            </button>
            <button 
              className={`filter-btn ${filterStatus === 'expiring' ? 'active' : ''}`}
              onClick={() => setFilterStatus('expiring')}
            >
              <FaUserClock /> Expiring Soon
            </button>
            <button 
              className={`filter-btn ${filterStatus === 'expired' ? 'active' : ''}`}
              onClick={() => setFilterStatus('expired')}
            >
              <FaUserTimes /> Expired
            </button>
          </div>
        </div>
      </section>

      {/* Members Grid Section */}
      <section className="members-section">
        <div className="container">
          {loading ? (
            <div className="no-results">
              <div className="spinner"></div>
              <h3>Loading members...</h3>
            </div>
          ) : (
            <>
              <div className="members-grid">
                {filteredMembers.length > 0 ? (
                  filteredMembers.map(member => (
                    <div key={member.id} className="member-card">
                      <div className="member-header">
                        <div className="member-avatar">
                          <img src={member.avatar} alt={member.name} />
                        </div>
                        <div className="member-badge">
                          <FaIdCard /> #{member.membershipNo.split('-').pop()}
                        </div>
                        <h3 className="member-name">{member.name}</h3>
                        <div className="member-title">
                          <FaUserTie /> {member.title}
                        </div>
                      </div>
                      
                      <div className="member-details">
                        <div className="membership-number">
                          <FaIdCard className="detail-icon" />
                          <div className="detail-content">
                            <span className="detail-label">Membership No:</span>
                            {member.membershipNo}
                          </div>
                        </div>

                        <div className="validity-period">
                          <FaCalendarAlt className="detail-icon" />
                          <div className="detail-content">
                            <span className="detail-label">Valid Period:</span>
                            {new Date(member.validityStart).toLocaleDateString()} - {new Date(member.validityEnd).toLocaleDateString()}
                            {getStatusBadge(member.status)}
                          </div>
                        </div>

                        <div className="detail-item">
                          <FaBuilding className="detail-icon" />
                          <div className="detail-content">
                            <span className="detail-label">Company:</span>
                            {member.company}
                          </div>
                        </div>

                        <div className="detail-item">
                          <FaEnvelope className="detail-icon" />
                          <div className="detail-content">
                            <span className="detail-label">Email:</span>
                            <a href={`mailto:${member.email}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                              {member.email}
                            </a>
                          </div>
                        </div>

                        <div className="detail-item">
                          <FaPhone className="detail-icon" />
                          <div className="detail-content">
                            <span className="detail-label">Phone:</span>
                            {member.phone}
                          </div>
                        </div>

                        <div className="location-info">
                          <div className="location-detail">
                            <MdLocationOn className="detail-icon" />
                            <div className="detail-content">
                              <span className="detail-label">Location:</span>
                              {member.location.address}
                            </div>
                          </div>

                          {/* Google Maps Integration */}
                          <div className="map-container">
                            {selectedMap === member.id ? (
                              <div className="map-wrapper">
                                {mapsLoading[member.id] && (
                                  <div className="map-loading">
                                    <div className="spinner"></div>
                                  </div>
                                )}
                                <iframe
                                  title={`Map for ${member.name}`}
                                  width="100%"
                                  height="200"
                                  frameBorder="0"
                                  style={{ border: 0, borderRadius: '8px' }}
                                  src={`https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${encodeURIComponent(member.location.address)}`}
                                  allowFullScreen
                                  loading="lazy"
                                  onLoad={() => setMapsLoading(prev => ({ ...prev, [member.id]: false }))}
                                ></iframe>
                              </div>
                            ) : (
                              <div 
                                className="map-placeholder"
                                onClick={() => loadGoogleMap(member.id, member.location)}
                              >
                                <FaMapMarkedAlt />
                                <span>Click to load map</span>
                              </div>
                            )}
                          </div>

                          <button 
                            className="direction-btn"
                            onClick={() => getDirections(member.location)}
                          >
                            <FaDirections /> Get Directions via Google Maps
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-results">
                    <FaSearch size={50} />
                    <h3>No members found</h3>
                    <p>Try adjusting your search or filter criteria</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <FaUsers />
              <div className="stat-number">{statistics.total}</div>
              <div className="stat-label">Total Members</div>
            </div>
            <div className="stat-card">
              <FaUserCheck />
              <div className="stat-number">{statistics.active}</div>
              <div className="stat-label">Active Members</div>
            </div>
            <div className="stat-card">
              <FaUserClock />
              <div className="stat-number">{statistics.expiring}</div>
              <div className="stat-label">Expiring Soon</div>
            </div>
            <div className="stat-card">
              <FaUserTimes />
              <div className="stat-number">{statistics.expired}</div>
              <div className="stat-label">Expired Members</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Membership;
